const ROUTES = {
  ADMIN_PANEL: '/bo',
  BASENAME: '/fo',
  CONTENT: '/content',
  CATEGORY_CONTENTS: '/contentcategory',
  CHALLENGE: '/challenge',
  DECLARE: '/declare',
  HISTORY: '/history',
  FORGOT_PASSWORD: '/auth/forgot-password',
  HOME: '/',
  LOGIN: '/auth',
  RESET_PASSWORD: '/auth/reset-password',
  CREATE_NEW_PASSWORD: '/auth/create/password',
  SSO_FAILURE: '/auth/sso-failure',
  SUBSCRIBE: '/auth/subscribe',
  SSO_AZURE_CONNECT: '/v2/connect/azure',

  STORE_HOME: '/store',
  STORE_FAVORITE: '/store/wishlist',
  STORE_ACCOUNT: '/account/details',
  STORE_CONTACT: '/account/contact'
} as const;

export default ROUTES;
